module.exports = __webpack_public_path__ + "img/sao.9568afa2.jpg";